module.exports = __webpack_public_path__ + "static/media/bell.7c2465f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/bell.svg
// module id = 866
// module chunks = 21